import { render, staticRenderFns } from "./ShippingAddFormConfigBearer.vue?vue&type=template&id=48e58b90"
import script from "./ShippingAddFormConfigBearer.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormConfigBearer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports